export default class AudioSource {
  constructor({ context, urlList, onsuccess, onerror }) {
    this.context = context;
    this.urlList = urlList;
    this.onload = onsuccess;
    this.onerror = onerror;
    this.bufferList = new Array();
    this.sounds = new Array();
    this.soundBuffer = new Array();
    this.loadCount = 0;
  }

  loadBuffer(url, index) {
    return new Promise((resolve, reject) => {
      const request = new XMLHttpRequest();
      request.open('GET', url, true);
      request.responseType = 'arraybuffer';
  
      request.onload = () => {
        this.context.decodeAudioData(
          request.response,
          (buffer) => {
            if (!buffer) {
              console.error('error decoding file data: ' + url);
              reject();
            }
  
            this.bufferList[index] = buffer;
            this.prepareSound(index);
            this.sounds[index] = null;
  
            resolve();
          },
          (error) => {
            console.error(error);
            reject(error);
          }
        );
      };
    
      request.onerror = function() {
        reject();
      };
    
      request.send();
    });
  }

  prepareSound(index) {
    this.soundBuffer[index] = this.context.createBufferSource();
    this.soundBuffer[index].buffer = this.bufferList[index];
    this.soundBuffer[index].connect(this.context.destination);
  }

  loadAllSources() {
    return new Promise((resolve) => {
      let successCounter = 0;

      for (let i = 0; i < this.urlList.length; ++i) {
        this.loadBuffer(this.urlList[i], i)
          .finally(() => {
            successCounter += 1;
            if (successCounter === this.urlList.length) resolve();
          });
      }
    });
  }

  start(index) {
    this.soundBuffer[index].start(0);
    this.sounds[index] = this.soundBuffer[index];
    this.prepareSound(index);
  }

  play(index) {
    return new Promise((resolve, reject) => {
      const audioBufferSourceNode = this.soundBuffer[index];
      audioBufferSourceNode.onended = resolve;
      audioBufferSourceNode.start(0);
      this.sounds[index] = audioBufferSourceNode;
      this.prepareSound(index);
     
    });
  }

  async playAll() {
    for (let i = 0; i < this.soundBuffer.length; i++) {
      if (this.soundBuffer[i]) {
        await this.play(i);
      }
    }
  }
}
